export default {
  roles: {
    name: '',
    fields: {
      name: 'บทบาท',
      property: 'โครงการ',
      access_level: 'ระดับการเข้าถึง',
      active: 'สถานะ',
      feature: 'ฟีเจอร์',
      action: {
        create: 'สร้าง',
        read: 'อ่าน',
        update: 'แก้ไข',
        delete: 'ลบ',
        export: 'Export',
        approve: 'อนุมัติ',
      },
      all_permission: 'สิทธิการเข้าถึงทั้งหมด',
    },
    create: { title: 'สร้าง บทบาท และ สิทธิการเข้าถึง' },
    edit: { title: 'แก้ไข บทบาท และ สิทธิการเข้าถึง' },
  },
}
